export default "__VITE_ASSET__Dlumuo24__"